import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import '../../styles/messagePane.scss';
import Textarea from 'react-textarea-autosize';
import {withExperiments} from 'wix-experiments-react';
import {TYPE_YOUR_MESSAGE} from '../../constants/messages';
import EmojiPanel from '../EmojiPanel/EmojiPanel';
import MessagePaneButtons from '../MessagePaneButtons/MessagePaneButtons';
import {toggleEmojiPanel, clickOnEmoji, clickOnAttachment} from '../../actions';
import {UNSUPPORTED_FORMAT, FILE_TOO_LARGE} from '../../constants/upload-file-errors';
import {getAttachmentType, attachmentTypes} from 'inbox-common/dist/src/attachments';

class MessagePane extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null
    };
  }

  onKeyDown(e) {
    if (e.which === 13 && !(e.shiftKey || e.ctrlKey)) {
      if (this.props.message.trim()) {
        this.handleSend();
      }
      e.preventDefault();
    }
  }

  onChange(e) {
    this.props.handleChange(e.target.value);
  }

  onEmojiClick(emoji, unicode) {
    this.props.clickOnEmoji(emoji, unicode);
    this.nameInput.focus();
  }

  onFileSelect(file) {
    if (this.isFileTypeSupported(file)) {
      if (this.isFileTooLarge(file)) {
        this.setState({error: FILE_TOO_LARGE});
      } else {
        this.props.handleFileUpload(file);
      }
    } else {
      this.setState({error: UNSUPPORTED_FORMAT});
    }
  }

  isFileTooLarge(file) {
    return file.size > 1024 * 1024 * 15;
  }

  isFileTypeSupported(file) {
    return [
      attachmentTypes.IMAGE,
      attachmentTypes.DOC,
      attachmentTypes.PPT,
      attachmentTypes.XLS,
      attachmentTypes.PDF
    ].indexOf(getAttachmentType(file.type)) > -1;
  }

  handleSend() {
    this.props.handleSend();
    this.props.toggleEmojiPanel(false);
  }

  toggleEmojiPanel() {
    this.props.toggleEmojiPanel(!this.props.emojiPanel);
    this.nameInput.focus();
  }

  clickErrorOk() {
    this.setState({error: null});
  }

  render() {
    const shouldShowEmojiButton = !this.props.isMobile;
    const shouldShowAttachmentButton = this.props.experiments.enabled('specs.com.VisitorAttachments');

    const {error} = this.state;
    if (error) {
      return (
        <div className="error">
          <p>{error}</p>
          <button onClick={() => this.clickErrorOk()}>OK</button>
        </div>
      );
    }

    return (
      <div className="message-pane-wrapper">
        <EmojiPanel className={this.props.emojiPanel ? '' : 'hidden'} onEmojiClick={(emoji, unicode) => this.onEmojiClick(emoji, unicode)}/>
        <div className={`textarea-wrapper${shouldShowEmojiButton ? ' with-emojis' : ''}`}>
          <Textarea
            aria-label="Type your message. Hit enter to submit"
            inputRef={input => this.nameInput = input}
            maxRows={5}
            role="textbox"
            className="message-pane-input"
            value={this.props.message}
            onKeyDown={e => this.onKeyDown(e)}
            onChange={e => this.onChange(e)}
            placeholder={TYPE_YOUR_MESSAGE}
            />
          <MessagePaneButtons
            shouldShowEmojiButton={shouldShowEmojiButton}
            shouldShowAttachmentButton={shouldShowAttachmentButton}
            handleEmojiPaneToggle={() => this.toggleEmojiPanel()}
            handleSend={e => this.handleSend(e)}
            shouldShowSend={!!this.props.message.trim()}
            onAttachmentClick={this.props.onAttachmentClick}
            onFileSelect={file => this.onFileSelect(file)}
            />
        </div>
      </div>
    );
  }
}

MessagePane.propTypes = {
  handleChange: PropTypes.func,
  handleSend: PropTypes.func,
  clickOnEmoji: PropTypes.func,
  onAttachmentClick: PropTypes.func,
  toggleEmojiPanel: PropTypes.func,
  handleFileUpload: PropTypes.func,
  message: PropTypes.string,
  emojiPanel: PropTypes.bool,
  isMobile: PropTypes.bool,
  experiments: PropTypes.any
};

function mapStateToProps(state) {
  return {
    emojiPanel: state.emojiPanel
  };
}

const mapDispatchToProps = dispatch => ({
  clickOnEmoji: (emoji, unicode) => dispatch(clickOnEmoji(emoji, unicode)),
  toggleEmojiPanel: isOpen => dispatch(toggleEmojiPanel(isOpen)),
  onAttachmentClick: () => dispatch(clickOnAttachment()),

});

export default withExperiments(connect(mapStateToProps, mapDispatchToProps)(MessagePane));




// WEBPACK FOOTER //
// ./chat-app/components/MessagePane/MessagePane.js